import {
  LOADING_ON,
  CHAT_LIST_DATA_LOAD,
  CHATROOM_DATA_LOAD,
  SELECT_CHAT,
  ADD_NEW_MESSAGE
} from '../constants/actionTypes'

export const isLoading = () => ({
  type: LOADING_ON
})

export const chatListDataLoad = data => ({
  type: CHAT_LIST_DATA_LOAD,
  data
})

export const chatRoomDataLoad = data => ({
  type: CHATROOM_DATA_LOAD,
  data
})

export const selectChat = chatId => ({
  type: SELECT_CHAT,
  chatId
})

export const addNewMessage = (message, chatId) => ({
  type: ADD_NEW_MESSAGE,
  message,
  chatId
})
